import { gql } from '@apollo/client';

const ADDRESS_FRAGMENT = gql`
  fragment AddressFragment on User {
    address1
    address2
    city
    zip
    state
  }
`;

export default ADDRESS_FRAGMENT;
